<template>
  <div  id="Login-View" class="login-view">
    <div class="form-signin">
      <Logo></Logo>
      <h1 class="h3 mt-5 mb-3 font-weight-normal">Routing Test Tool</h1>
      <b-button size="lg" variant="primary" block v-on:click="signIn" class="icon-container">
        <i class="material-icons">fingerprint</i>
        <span>Sign in with Google</span>
      </b-button>
      <p class="mt-5 mb-3 text-muted">© Rebtel</p>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
export default {
  name: 'Login',
  components: {
    Logo
  },
  created () {
  },
  methods: {
    signIn: async function () {
      try {
        const googleUser = await this.$gAuth.signIn()
        this.$store.dispatch('auth/authenticate', {googleUser}).then(() => {
          if (process.env.NODE_ENV === 'production') {
            this.$toastr.i('This is production environment')
          }
          var redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        }).catch((error) => {
          this.$toastr.e(error)
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-view {
  height: 100vh;
  min-height: 315px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue